import React from 'react';
import PropTypes from 'prop-types';

import { contractTypes } from '../../utils/commonFormsConfig';

const ContractConfirm = ({ history, t }) => {
  const consumption = history?.location?.state?.type === contractTypes.consumption;

  let url = "https://mobility.dufercoenergia.com";
  if(process.env.REACT_APP_ENV !== 'production') {
    url = "https://test-mobility.dufercoenergia.com";
  }

  return <div className='row'>
    <div className='col'>
      <div name='info-msg-container' className='info-msg-container'>
        <div className='row'>
          <div className='col-md-10 offset-md-1 col-xl-8 offset-xl-2'>
            <div className='msg'>
            <h1>{t('contractConfirm.title')}</h1>
            <p>{!consumption ? t('contractConfirm.subtitle_1') : t('contractConfirm.subtitle_cons')}</p>
            {!consumption && <p>{t('contractConfirm.subtitle_2')}</p>}
            <a className='btn btn-lg btn-success my-2 text-uppercase' href={url}>{t('contractConfirm.action')}</a>
            <p className='af-btn'>{t('contractConfirm.info')}</p>
            <p>{t('contractConfirm.phone')} <a href='tel:800922200'>800.92.22.00</a></p>
            <p>{t('contractConfirm.mail')} <a href='mailto:mobility@dufercoenergia.com' target='_blank' rel='noreferrer'>mobility@dufercoenergia.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

ContractConfirm.propTypes = {
  history: PropTypes.object,
  t: PropTypes.func
};

export default ContractConfirm;
